import React from 'react';
import { AuthProvider } from '@app/react-common/auth/AuthContext';
import { AppProvider } from '@app/react-common/AppContext';
import { Router } from './router/Router';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';
import { Observable, Subject } from 'rxjs';
import { AngularAction } from './models/AngularAction';

interface CheckoutProps {
  jwtToken: string;
  shop$: Observable<Shop>;
  angularRoutingSubject: Subject<string>;
  angularActionSubject: Subject<AngularAction>;
}

export const CheckoutRoot = ({ jwtToken, shop$, angularRoutingSubject, angularActionSubject }: CheckoutProps) => {
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <AuthProvider authToken={jwtToken}>
        <AppProvider
          shop$={shop$}
          angularRoutingSubject={angularRoutingSubject}
          angularActionSubject={angularActionSubject}>
          <Router />
          <div id="modal-root"></div>
        </AppProvider>
      </AuthProvider>
    </React.Suspense>
  );
};
